/**
 * The Patreon API version that is being used by this library
 */
export const APIVersion = 2